module.exports = __webpack_public_path__ + "static/media/logo-aigeeks-footer.572567f0.svg";